// Small reusable confirmation dialog for destructive/soft-delete actions.
// Keeps the focus on a single decision; the confirm button colour signals the
// action's weight (defaults to a cautionary "error" red).
import {
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button,
} from '@mui/material';

const ConfirmDialog = ({
  open, title, message, confirmLabel = 'Confirm', confirmColor = 'error',
  onConfirm, onCancel,
}) => (
  <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText>{message}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel}>Cancel</Button>
      <Button onClick={onConfirm} color={confirmColor} variant="contained">
        {confirmLabel}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDialog;
